// extracted by mini-css-extract-plugin
export default {"container":"CnpjCpf_container__zEHY5"};